import React, { useEffect, useState } from 'react';
import { Button, Modal, Row, Col } from 'react-bootstrap'
import MultiCarouselPage from './MultiCarouselPage'
import UserService from "../controllers/UserService";
import strengths from "../files/strengths.json";
import AuthService from '../controllers/AuthService';

const SumStorySSE = props => {
    const [title, setTitle] = useState('');
    const [maxStudent, setMaxStudent] = useState(0);
    const [answer1, setAnswer1] = useState([]);
    const [answer2, setAnswer2] = useState([]);
    const [answer3, setAnswer3] = useState([]);
    const [teacherAnswer, setTeacherAnswer] = useState("");

    const [activityQuestions, setActivityDetail] = useState([]);
    const [answersPercent, setAnswersPercent] = useState([]);

    const [modalShow, setModalShow] = useState(false);

    const [modalShowAnswer, setModalShowAnswer] = useState(0);
    const [modalShowEndActivity, setModalShowEndActivity] = useState(false);
    const [validateType, setValidateType] = useState(null);

    const [isCreatedActivityByMe, setIsCreatedActivityByMe] = useState(true);

    let realAnswer1 = [];
    let realAnswer2 = [];
    let realAnswer3 = [];

    const [answersSlide1, setAnswersSlide1] = useState([]);
    const [answersSlide2, setAnswersSlide2] = useState([]);

    const onChangeTeacherAnswer = (e) => {
        const answer = e.target.value;
        setTeacherAnswer(answer);
    };

    useEffect(() => {
        UserService.getActivityDetail(props.activityId).then((res) => {
            var questions = [
                res.data.data.topic.questions[0].content,
                res.data.data.topic.questions[1].content,
                res.data.data.topic.questions[2].content,
            ]
            setActivityDetail(questions)
            setTitle(res.data.data.topic.title)
            setMaxStudent(res.data.data.maxStudent)
            if (res && res.data && res.data.data && res.data.data.status && res.data.data.status === 'FINISHED') {
                window.location.href = `/activity/summary/${props.activityId}`
            }
            if (res && res.data && res.data.data && res.data.data.createdBy && res.data.data.createdBy.id && res.data.data.createdBy.id === AuthService.getCurrentUserId()) {
                setIsCreatedActivityByMe(false)
            }
            return [
                res.data.data.topic.questions[0].id,
                res.data.data.topic.questions[1].id,
                res.data.data.topic.questions[2].id
            ]

        }).then((res) => {
            if (res.length > 0) {
                const sse1 = new EventSource(`${process.env.REACT_APP_API_ENDPOINT}/sse/activities/${props.activityId}/questions/${res[0]}/answers-percent`);
                const sse2 = new EventSource(`${process.env.REACT_APP_API_ENDPOINT}/sse/activities/${props.activityId}/questions/${res[1]}/answers`);
                const sse3 = new EventSource(`${process.env.REACT_APP_API_ENDPOINT}/sse/activities/${props.activityId}/questions/${res[2]}/answers`);
                sse1.onmessage = e => setTimeout(() => { getAnswerData(JSON.parse(e.data), 1); }, 5000);
                sse2.onmessage = e => setTimeout(() => { getAnswerData(JSON.parse(e.data), 2); }, 5000);
                sse3.onmessage = e => setTimeout(() => { getAnswerData(JSON.parse(e.data), 3); }, 5000);
                // sse1.onerror = () => {
                //     sse1.close();
                // }
                // sse2.onerror = () => {
                //     sse2.close();
                // }
                // sse3.onerror = () => {
                //     sse3.close();
                // }
                return (() => { sse1.close(); sse2.close(); sse3.close(); })
            }
        })
    }, [])

    if(!window.localStorage.getItem('is-refresh')) {
        window.onpageshow = event => {
            if (event.persisted) {
            window.localStorage.setItem('is-refresh', true);
            window.location.reload();
            }
        }
    } else {
        window.localStorage.removeItem('is-refresh');
    }

    const getAnswerData = (data, answerNo) => {

        if (answerNo === 1) {
            realAnswer1 = data.percentages
            var percent = [];
            var tempPercent = 0;
            var stringHtml;
            var myArr = Object.fromEntries(
                Object.entries(realAnswer1).sort(([, a], [, b]) => b - a)
            );

            Object.keys(myArr).map((aArray, i) => {
                tempPercent = realAnswer1[aArray]
                stringHtml = `<div key="${i}" class="primary-text percent-font" data-value="1"><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100" /><br>${tempPercent.toFixed(2)}%</div>`;
                var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} className="anywhere-wrap" />
                percent.push(temp);
            })

            strengths.map((strength, i) => {

                if (!realAnswer1[strength.value]) {
                    tempPercent = 0;
                    stringHtml = `<div key="${i}"  class="primary-text percent-font" data-value="1"><img src='/images/strengths/cards/${strength.imagePath}' class="d-inline w-100" /><br>${tempPercent.toFixed(2)}%</div>`
                    var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} class="anywhere-wrap" />
                    percent.push(temp)
                }
            })

            setAnswersPercent(percent);
        } else if (answerNo === 2) {


            if (!realAnswer2.find(x => x.id === data.id)) {
                if (data.id && data.id !== "0" && data.answer) {
                    realAnswer2.push({ id: data.id, text: data.answer })
                }

            }

            // if (realAnswer2.length <= 4) {

            const items = []
            const slide = []

            for (var i = 0; i < realAnswer2.length; i++) {
                // var shortTilte = realAnswer2[i].text;
                // if (realAnswer2[i].text.length > 340) {
                //     shortTilte = shortTilte.substring(0, 337) + " ...";
                // }

                var temp = `<div key="${i}" class="border-radius-12 p-3 div-ans" data-value="1"><div class="item text-left">${realAnswer2[i].text}</div></div>`;
                temp = <div dangerouslySetInnerHTML={{ __html: temp }} className="anywhere-wrap" />
                items.push(temp);
                // if (i <= 3) {
                slide.push(temp);
                // }
            }

            setAnswer2(items)
            // temp = `<div key="100" class="item p-3 bg-white text-center click-pointer" data-value="1"  id="answers1"><img style="height: 100%;" src="/images/icons/seemore.png" /></div>`
            // temp = <div dangerouslySetInnerHTML={{ __html: temp }} className="anywhere-wrap" />
            // slide.push(temp);
            setAnswersSlide1(slide);

            // }



        } else if (answerNo === 3) {

            if (!realAnswer3.find(x => x.id === data.id)) {
                if (data.id && data.id !== "0" && data.answer) {
                    realAnswer3.push({ id: data.id, text: data.answer })
                }
            }


            // if (realAnswer3.length <= 4) {

            const items = []
            const slide = []

            for (var i = 0; i < realAnswer3.length; i++) {
                // var shortTilte = realAnswer3[i].text;
                // if (realAnswer3[i].text.length > 340) {
                //     shortTilte = shortTilte.substring(0, 337) + " ...";
                // }
                var temp = `<div key="${i}" class="border-radius-12 div-ans p-3" data-value="1"><div class="item text-left">${realAnswer3[i].text}</div></div>`;
                temp = <div dangerouslySetInnerHTML={{ __html: temp }} className="anywhere-wrap" />
                items.push(temp);
                // if (i <= 3) {
                slide.push(temp);
                // }
            }

            setAnswer3(items)
            // temp = `<div key="100" class="item p-3 bg-white text-center click-pointer" data-value="1"  id="answers1"><img style="height: 100%;" src="/images/icons/seemore.png" /></div>`
            // temp = <div dangerouslySetInnerHTML={{ __html: temp }} className="anywhere-wrap" />
            // slide.push(temp);
            setAnswersSlide2(slide);

            // }
        }
        // setAnswer1(data.percentages)
        // setAnswer2(realAnswer2)
        // setAnswer3(realAnswer3)
    }

    const responsive3 = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.
        },
        tablet: {
            breakpoint: { max: 1024, min: 500 },
            items: 2,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        },
        mobile: {
            breakpoint: { max: 500, min: 0 },
            items: 1,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        }
    }
    const alertEndActivity = () => {
        if (teacherAnswer.length === 0) {
            setValidateType('answer-warning')
            setModalShowEndActivity(true)
        } else {
            setModalShowEndActivity(true)
        }
    }

    const handleCloseModal = () => {
        setModalShowEndActivity(false);
        setTimeout(() => { setValidateType(null); }, 500);
    }

    const endActivity = (activityId) => {
        UserService.postTeacherAnswer(activityId, { "comment": teacherAnswer }).then((res) => {
            if (res.data && res.data.status.code === 'SUCCESS') {
                handleCloseModal()
                UserService.endActivity(activityId).then(
                    (res2) => {
                        if (res2.data && res2.data.status.code === 'SUCCESS') {
                            window.location.href = `/activity/summary/${props.activityId}`
                        }
                    },
                    (error) => {
                        const resMessage =
                            (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            error.message ||
                            error.toString();
                        console.log(resMessage);
                        
                        if (error.response && error.response.data && error.response.data.status && error.response.data.status.code === 'UNAUTHORIZED') {
                            AuthService.logout();
                            window.location.href = '/login'
                        } else {
                            alert(`เกิดข้อผิดพลาดบางอย่าง กรุณา capture หน้าจอนี้แล้วแจ้งผู้ประสานงาน : ${resMessage}`)
                        }
                    }
                );
            }
        },
            (error) => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                
                if (error.response && error.response.data && error.response.data.status && error.response.data.status.code === 'UNAUTHORIZED') {
                    AuthService.logout();
                    window.location.href = '/login'
                } else {
                    alert(`เกิดข้อผิดพลาดบางอย่าง กรุณา capture หน้าจอนี้แล้วแจ้งผู้ประสานงาน : ${resMessage}`)
                }
            })

    }

    const showPopupAnswer = (answerId) => {
        if (modalShow === false) {
            setModalShow(true);
            setModalShowAnswer(answerId)
        }
    }

    return (
        <div className="mx-3">
            <Row className="blue-bg">
                <Col className="sum-story px-0 blue-bg font-sarabun">
                    <Row className="mx-0">
                        <Col className="main-detail px-4">
                            <h2 className="primary-text font-weight-600">{title}</h2>
                        </Col>
                    </Row>
                    <Row className="pt-3 mt-0 mx-0">
                        <Col className="main-detail px-4">
                            <h3 className="py-1 bg-blue-grey border-radius-5 font-weight-600">คำตอบจากนักเรียน ({answer2.length}/{maxStudent}) คน</h3>
                        </Col>
                    </Row>

                    <Row className="pt-3 mx-0">
                        <Col className="primary-text main-detail px-4">
                            <h3 className="pb-0 mb-0 font-weight-600">3 คุณค่าจากนิสัยเชิงบวก</h3>
                        </Col>
                    </Row>

                    <Row className="py-3 mx-0">
                        <Col className="text-left main-detail px-4">
                            <h4>{activityQuestions[0]}</h4>
                        </Col>
                    </Row>
                    <Row className="py-3 mx-0">
                        <Col className="main-detail px-4">
                            <MultiCarouselPage data={answersPercent} responsive={responsive3} />
                        </Col>
                    </Row>

                    <Row className="pt-4 pt-md-5 mt-3 bg-white mx-0">
                        <Col className="primary-text main-detail px-4">
                            <h3 className="pb-0 mb-0 font-weight-600">มุมมองของนักเรียนที่มีต่อเรื่องราวนี้</h3>
                        </Col>
                    </Row>

                    <Row className="py-3 mx-0 bg-white">
                        <Col className="text-left main-detail px-4">
                            <h4>{activityQuestions[1]}</h4>
                        </Col>
                    </Row>

                    <Row className="py-3 bg-white mx-0">
                        {/* <Col xs={12} align="right"><a href="javascript:void(0)" onClick={() => {showPopupAnswer(2)}}>ดูทั้งหมด</a></Col> */}
                        <Col xs={12} className="main-detail px-4">
                            <MultiCarouselPage data={answersSlide1} responsive={responsive3} />
                        </Col>
                    </Row>

                    <Row className="mt-0 bg-light-blue mx-0" style={{ 'height': '20px' }} />

                    <Row className="pt-4 pt-md-5 bg-white mx-0">
                        <Col className="primary-text main-detail px-4">
                            <h3 className="pb-0 mb-0 font-weight-600">แรงบันดาลใจที่ได้รับจากเรื่องราว</h3>
                        </Col>
                    </Row>

                    <Row className="py-3  bg-white mx-0">
                        <Col className="text-left main-detail px-4">
                            <h4>{activityQuestions[2]}</h4>
                        </Col>
                    </Row>

                    <Row className="py-3 bg-white mx-0">
                        {/* <Col xs={12} align="right"><a href="javascript:void(0)" onClick={() => {showPopupAnswer(3)}}>ดูทั้งหมด</a></Col> */}
                        <Col className="main-detail px-4">
                            <MultiCarouselPage data={answersSlide2} responsive={responsive3} />
                        </Col>
                    </Row>

                    <Row className="pt-4 pt-md-5 mt-0 bg-light-blue mx-0">
                        <Col className="main-detail px-4">
                            <h3 className="py-1 bg-blue-grey border-radius-5 font-weight-600">ความคิด และความรู้สึกของครู</h3>
                            <h4 className="pt-1 pt-md-3 text-left">เมื่อได้อ่านมุมมองของนักเรียนที่มีต่อเรื่องราวในวันนี้ ชวนคุณครูบันทึก ความคิด และความรู้สึกที่เกิดขึ้นเพื่อสะท้อนคิดเรียนรู้ และเติบโตไปพร้อมกัน</h4>
                        </Col>
                    </Row>
                    <Row className="pb-3 py-md-3 mx-0 bg-light-blue">
                        <Col className="main-detail px-4" >
                            <div className="border-radius-12 border-gray p-3 bg-white text-left overflow-7 ">
                                <textarea className="w-100 text no-border-line" placeholder="ลองเล่าให้เราฟังหน่อย..." style={{ height: '170px' }} onChange={onChangeTeacherAnswer}></textarea>
                            </div>
                        </Col>
                    </Row>
                    <Row className="pb-3 py-md-3 mx-0">
                        <Col className="main-detail px-4">
                            <Button className="bluebtn d-inline py-1 py-md-2 px-3 font-weight-600" onClick={() => alertEndActivity()} disabled={isCreatedActivityByMe}>จบกิจกรรม</Button>
                        </Col>
                    </Row>
                </Col >
            </Row >
            <Modal
                size="lg"
                show={modalShow}
                onHide={() => handleCloseModal()}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="answerModal"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-sm">
                        Answer
                </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ 'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto' }}>
                    <Col align="left">
                        {modalShowAnswer === 2 ? (
                            answer2.map((answer, i) => (
                                <div className="item my-1 my-md-2 p-3">
                                    {answer.text}
                                </div>
                            ))
                        ) : modalShowAnswer === 3 ? (
                            answer3.map((answer, i) => (
                                <div className="item my-1 my-md-2 p-3">
                                    {answer.text}
                                </div>
                            ))
                        ) : (<div></div>)}
                        { }
                    </Col>
                </Modal.Body>
            </Modal>
            <Modal
                show={modalShowEndActivity}
                onHide={() => { handleCloseModal(); }}
                aria-labelledby="contained-modal-title-vcenter"
                // className="strength-modal"
                centered
                className="alert-modal"
            >
                {(validateType === 'answer-warning') ? (
                    <Modal.Body className="font-sarabun text-center py-4">
                        <p>คุณครูยังไม่ได้แสดงความคิด
                            และความรู้สึกเลยนะคะ</p>
                        <Button className="bluebtn d-inline py-1 py-md-2 px-3 font-sarabun-bold border-radius-10" onClick={() => { handleCloseModal(); }}>กลับกิจกรรม</Button>
                    </Modal.Body>
                ) : (
                    <div>
                        <Modal.Header closeButton className="alert-header">
                        </Modal.Header>
                        <Modal.Body className="font-sarabun text-center pb-4 pt-0">
                            <p>คุณต้องการจบกิจกรรมใช่หรือไม่? <br />หากจบกิจกรรมแล้ว ทุกคนจะไม่สามารถดำเนินกิจกรรมต่อได้ <br />
    และผลของกิจกรรมจะเก็บเข้าในรายงาน</p>
                            <Button className="bluebtn d-inline py-1 py-md-2 px-3 m-1 font-sarabun-bold border-radius-10" onClick={() => { handleCloseModal(); }}>กลับกิจกรรม</Button>
                            <Button className="bluegrey d-inline py-1 py-md-2 px-3 m-1 font-sarabun-bold border-radius-10" onClick={() => endActivity(props.activityId)}>ตกลง</Button>

                        </Modal.Body>
                    </div>
                )}
            </Modal>

        </div >
    )

}

export default SumStorySSE